import {type BoxTags, Paper as GWCPaper} from '@gwc/main'
import {type ReactElement, forwardRef} from 'react'
import clsx from 'clsx'

import * as classes from './Paper.classes'
import type {PaperProps, AnyPaperProps} from './types'

export const Paper = forwardRef(function Paper<C extends Function | BoxTags>(props: PaperProps<C>, ref): ReactElement {
  const {item, float, className: classNameProp, ...paperProps} = props

  if (float) {
    return (
      <GWCPaper {...paperProps} ref={ref} className={clsx(classes.floatRoot, classes.float[float], classNameProp)} />
    )
  }

  return (
    <GWCPaper
      {...paperProps}
      ref={ref}
      className={clsx(
        item && classes.item,
        item === 'header' && classes.header,
        item === 'footer' && classes.footer,
        classNameProp,
      )}
      mt={getMarginTop(props)}
      flexDirection={getFlexDirection(props)}
      flexGrow={getFlexGrow(props)}
    />
  )
}) as <C extends Function | BoxTags>(props: PaperProps<C>) => ReactElement

function getMarginTop(props: AnyPaperProps): AnyPaperProps['mt'] {
  if ('mt' in props) {
    return props.mt
  }

  if (props.item) {
    if (props.item !== 'header') {
      return 'xs'
    }
  }
}

function getFlexDirection(props: AnyPaperProps): AnyPaperProps['flexDirection'] {
  if ('flexDirection' in props) {
    return props.flexDirection
  }

  if (props.item) {
    return 'column'
  }
}

function getFlexGrow(props: AnyPaperProps): AnyPaperProps['flexGrow'] {
  if ('flexGrow' in props) {
    return props.flexGrow
  }

  if (props.item) {
    if (props.item !== 'header') {
      return 1
    }
  }
}
